import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/app/[lng]/components/faqs-section/faqs-section.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/app/icons/assistance.svg");
;
import(/* webpackMode: "eager" */ "/vercel/path0/app/icons/developers.svg");
;
import(/* webpackMode: "eager" */ "/vercel/path0/app/icons/learnMore.svg");
;
import(/* webpackMode: "eager" */ "/vercel/path0/app/icons/search-icon.svg");
;
import(/* webpackMode: "eager" */ "/vercel/path0/app/icons/technical-support.svg");
;
import(/* webpackMode: "eager" */ "/vercel/path0/app/icons/user-guide.svg");
